import { useForm } from '@mantine/form';
import { IconCheck } from '@tabler/icons-react';
import FormWrapper from 'components/forms/FormWrapper';
import { FormProps } from 'components/forms/FormProps';
import useLoadingAction from 'hooks/use-loading-action';
import { noop } from 'lodash';
import FormInputGroup from 'components/forms/FormInputGroup';
import ColumnPairings from 'components/forms/remote-source/config/ColumnPairings';
import { XlsxConfig } from 'components/forms/remote-source/config/types';

interface XlsxConfigFormProps extends FormProps<XlsxConfig> {}

/**
 * Configuration form placeholder for XLSX remote sources.
 */
export default function XlsxConfigForm({
  initialValues = { devices: [], revisionPlans: [], faults: [] },
  onSubmit = noop,
}: XlsxConfigFormProps) {
  const [{ loading }, submit] = useLoadingAction(onSubmit);
  const form = useForm<XlsxConfig>({ initialValues });

  return (
    <FormWrapper
      onSubmit={form.onSubmit(submit)}
      loading={loading}
      primaryButtonText="Uložiť"
      primaryIcon={<IconCheck stroke="1.5" height={24} width={24} />}
      skipSecondaryButtonConfirm={!form.isDirty()}
    >
      <FormInputGroup groupTitle="Zariadenia">
        <ColumnPairings form={form} formProp="devices" propType="device" autoNameColumns />
      </FormInputGroup>
      <FormInputGroup groupTitle="Termíny">
        <ColumnPairings form={form} formProp="revisionPlans" propType="plan" autoNameColumns />
      </FormInputGroup>
      <FormInputGroup groupTitle="Nedostatky">
        <ColumnPairings form={form} formProp="faults" propType="fault" autoNameColumns />
      </FormInputGroup>
    </FormWrapper>
  );
}
